import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { SimTypography } from 'components/SimTypography';

const SimSectionTitle = ({
	variant = 'h3',
	title = 'Title',
	subtitle = 'Sub-title',
	gutterBottom = true,
	children
}) => {
	const theme = useTheme();

	return (
		<Box marginBottom={4}>
			<SimTypography
				variant={variant}
				align={'center'}
				data-aos={'fade-up'}
				gutterBottom={gutterBottom}
				sx={{
					fontWeight: 700
				}}>
				{title}
			</SimTypography>
			{subtitle && (
				<SimTypography variant='h6' align={'center'} color={theme.palette.text.primary} data-aos={'fade-up'}>
					{children || subtitle}
				</SimTypography>
			)}
		</Box>
	);
};

export default SimSectionTitle;
